import { render, staticRenderFns } from "./placeselect.vue?vue&type=template&id=01668a91&"
import script from "./placeselect.vue?vue&type=script&lang=js&"
export * from "./placeselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports